import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0260f1d2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0260f1d2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0260f1d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/program/front/git/ams/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0260f1d2')) {
      api.createRecord('0260f1d2', component.options)
    } else {
      api.reload('0260f1d2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0260f1d2&scoped=true", function () {
      api.rerender('0260f1d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BreadcrumbV2/index.vue"
export default component.exports